/* tslint:disable */
/* eslint-disable */
/**
 * Azimut - NFE-DATAHUB
 * API Definition for Azimut - NFE-DATAHUB
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: az.tech.datahub@reply.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Anno
 */
export interface Anno {
    /**
     * 
     * @type {string}
     * @memberof Anno
     */
    'anno'?: string;
    /**
     * 
     * @type {number}
     * @memberof Anno
     */
    'importoInvestitoAnno'?: number;
    /**
     * 
     * @type {number}
     * @memberof Anno
     */
    'importoMaxInvestibileAnno'?: number;
    /**
     * 
     * @type {number}
     * @memberof Anno
     */
    'residuoInvestibileAnno'?: number;
}
/**
 * 
 * @export
 * @interface ApiError
 */
export interface ApiError {
    /**
     * 
     * @type {number}
     * @memberof ApiError
     */
    'http_code'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'error_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'message_error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'more_info'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'path_operation'?: string;
}
/**
 * 
 * @export
 * @interface Cliente
 */
export interface Cliente {
    /**
     * 
     * @type {string}
     * @memberof Cliente
     */
    'denominazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cliente
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cliente
     */
    'codRuolo'?: string;
}
/**
 * 
 * @export
 * @interface ClientePIR
 */
export interface ClientePIR {
    /**
     * 
     * @type {string}
     * @memberof ClientePIR
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientePIR
     */
    'codRuolo'?: string;
}
/**
 * 
 * @export
 * @interface ControlliBloccanti
 */
export interface ControlliBloccanti {
    /**
     * OK/KO se sono stati sollevati o meno controlli bloccanti
     * @type {string}
     * @memberof ControlliBloccanti
     */
    'esito'?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlliBloccanti
     */
    'numeroBloccanti'?: number;
    /**
     * 
     * @type {Array<ControlloBloccante>}
     * @memberof ControlliBloccanti
     */
    'dettaglio'?: Array<ControlloBloccante>;
}
/**
 * 
 * @export
 * @interface ControlliInSelfResponse
 */
export interface ControlliInSelfResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof ControlliInSelfResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {ControlliBloccanti}
     * @memberof ControlliInSelfResponse
     */
    'data'?: ControlliBloccanti;
}
/**
 * 
 * @export
 * @interface ControlloBloccante
 */
export interface ControlloBloccante {
    /**
     * 
     * @type {string}
     * @memberof ControlloBloccante
     */
    'idControllo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlloBloccante
     */
    'descrizione'?: string;
}
/**
 * 
 * @export
 * @interface Costituzione
 */
export interface Costituzione {
    /**
     * 
     * @type {string}
     * @memberof Costituzione
     */
    'dataCostituzione'?: string;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof Costituzione
     */
    'indirizzo'?: IndirizzoNFE;
}
/**
 * 
 * @export
 * @interface DatiAgente
 */
export interface DatiAgente {
    /**
     * 
     * @type {string}
     * @memberof DatiAgente
     */
    'codAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiAgente
     */
    'codClienteAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiAgente
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiAgente
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiAgente
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiAgente
     */
    'cellulare'?: string;
    /**
     * 
     * @type {IndirizzoUfficio}
     * @memberof DatiAgente
     */
    'indirizzoUfficio'?: IndirizzoUfficio;
}
/**
 * 
 * @export
 * @interface DatiGerarchia
 */
export interface DatiGerarchia {
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'codAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'idNodo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'codNodo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'desNodo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'desTipoNodo'?: string;
    /**
     * valorizzato con TRUE se il nodo corrente ha altri figli in gerarchia
     * @type {boolean}
     * @memberof DatiGerarchia
     */
    'flagIsPadre'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'idNodoPadre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'codNodoPadre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'desNodoPadre'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiGerarchia
     */
    'livello'?: string;
}
/**
 * 
 * @export
 * @interface DatiGerarchieResponse
 */
export interface DatiGerarchieResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof DatiGerarchieResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {DatiGerarchia}
     * @memberof DatiGerarchieResponse
     */
    'data'?: DatiGerarchia;
}
/**
 * 
 * @export
 * @interface DatiSimulaPIR
 */
export interface DatiSimulaPIR {
    /**
     * 
     * @type {string}
     * @memberof DatiSimulaPIR
     */
    'numeroSimula'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiSimulaPIR
     */
    'codAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatiSimulaPIR
     */
    'codCliente'?: string;
    /**
     * 
     * @type {Array<OperazioniSimulate>}
     * @memberof DatiSimulaPIR
     */
    'operazioniSimulate'?: Array<OperazioniSimulate>;
}
/**
 * 
 * @export
 * @interface DettagliProdotti
 */
export interface DettagliProdotti {
    /**
     * 
     * @type {string}
     * @memberof DettagliProdotti
     */
    'codTitolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DettagliProdotti
     */
    'desProdotto'?: string;
    /**
     * 
     * @type {number}
     * @memberof DettagliProdotti
     */
    'importoTotInvestito'?: number;
    /**
     * 
     * @type {number}
     * @memberof DettagliProdotti
     */
    'importoTotDisinvestito'?: number;
    /**
     * 
     * @type {number}
     * @memberof DettagliProdotti
     */
    'importoCommittment'?: number;
    /**
     * 
     * @type {number}
     * @memberof DettagliProdotti
     */
    'percentualeConcentrazione'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DettagliProdotti
     */
    'flagCompliant'?: boolean;
}
/**
 * 
 * @export
 * @interface Documento
 */
export interface Documento {
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'tipoDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'numeroDocumento'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'dataEmissione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'dataScadenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'desLocalitaEmissione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'codNazioneEmissione'?: string;
}
/**
 * 
 * @export
 * @interface DossierFiguraAcc
 */
export interface DossierFiguraAcc {
    /**
     * 
     * @type {string}
     * @memberof DossierFiguraAcc
     */
    'codDossier'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierFiguraAcc
     */
    'codRuolo'?: string;
}
/**
 * 
 * @export
 * @interface DossierRapporto
 */
export interface DossierRapporto {
    /**
     * 
     * @type {string}
     * @memberof DossierRapporto
     */
    'codDossier'?: string;
    /**
     * 
     * @type {Array<Cliente>}
     * @memberof DossierRapporto
     */
    'clienti'?: Array<Cliente>;
}
/**
 * 
 * @export
 * @interface FiguraAccessoria
 */
export interface FiguraAccessoria {
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'cellulare'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'idAddendum'?: string;
    /**
     * 
     * @type {string}
     * @memberof FiguraAccessoria
     */
    'codFiscale'?: string;
    /**
     * 
     * @type {Array<DossierFiguraAcc>}
     * @memberof FiguraAccessoria
     */
    'dossier'?: Array<DossierFiguraAcc>;
}
/**
 * 
 * @export
 * @interface GestoreAssociato
 */
export interface GestoreAssociato {
    /**
     * 
     * @type {string}
     * @memberof GestoreAssociato
     */
    'codAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof GestoreAssociato
     */
    'codGerarchia'?: string;
    /**
     * 
     * @type {string}
     * @memberof GestoreAssociato
     */
    'nomeAgente'?: string;
    /**
     * 
     * @type {string}
     * @memberof GestoreAssociato
     */
    'cognomeAgente'?: string;
    /**
     * 
     * @type {number}
     * @memberof GestoreAssociato
     */
    'percentualeSplit'?: number;
}
/**
 * 
 * @export
 * @interface IndirizzoNFE
 */
export interface IndirizzoNFE {
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'codNazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'codProvincia'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'cap'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'indirizzo'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoNFE
     */
    'desLocalita'?: string;
}
/**
 * 
 * @export
 * @interface IndirizzoUfficio
 */
export interface IndirizzoUfficio {
    /**
     * 
     * @type {string}
     * @memberof IndirizzoUfficio
     */
    'codNazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoUfficio
     */
    'codProvincia'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoUfficio
     */
    'cap'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoUfficio
     */
    'indirizzo'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndirizzoUfficio
     */
    'desLocalita'?: string;
}
/**
 * 
 * @export
 * @interface InfoPac
 */
export interface InfoPac {
    /**
     * 
     * @type {number}
     * @memberof InfoPac
     */
    'rataImporto'?: number;
    /**
     * 
     * @type {string}
     * @memberof InfoPac
     */
    'frequenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoPac
     */
    'dataFinePiano'?: string;
    /**
     * 
     * @type {number}
     * @memberof InfoPac
     */
    'numeroRatePrevisto'?: number;
    /**
     * 
     * @type {number}
     * @memberof InfoPac
     */
    'numeroRateTotale'?: number;
    /**
     * 
     * @type {number}
     * @memberof InfoPac
     */
    'numeroRateResiduo'?: number;
    /**
     * 
     * @type {number}
     * @memberof InfoPac
     */
    'importoPrimoVersamento'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InfoPac
     */
    'flagVersamentiSuccPac'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InfoPac
     */
    'durataAnni'?: number;
}
/**
 * 
 * @export
 * @interface LetturaDatiClientePF
 */
export interface LetturaDatiClientePF {
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'codFiscale'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'genere'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'cellulare'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'dataNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'comuneNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'provinciaNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'nazioneNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'contrattoMyAzimut'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePF
     */
    'codAccordoQuadro'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LetturaDatiClientePF
     */
    'flagIsMigrato'?: boolean;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof LetturaDatiClientePF
     */
    'residenza'?: IndirizzoNFE;
    /**
     * 
     * @type {Documento}
     * @memberof LetturaDatiClientePF
     */
    'documento'?: Documento;
}
/**
 * 
 * @export
 * @interface LetturaDatiClientePG
 */
export interface LetturaDatiClientePG {
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePG
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePG
     */
    'denominazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePG
     */
    'pIva'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePG
     */
    'codSpecieGiuridica'?: string;
    /**
     * 
     * @type {Array<FiguraAccessoria>}
     * @memberof LetturaDatiClientePG
     */
    'figuraAccessoria'?: Array<FiguraAccessoria>;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePG
     */
    'contrattoMyAzimut'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePG
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LetturaDatiClientePG
     */
    'codAccordoQuadro'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LetturaDatiClientePG
     */
    'flagIsMigrato'?: boolean;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof LetturaDatiClientePG
     */
    'residenza'?: IndirizzoNFE;
    /**
     * 
     * @type {Costituzione}
     * @memberof LetturaDatiClientePG
     */
    'costituzione'?: Costituzione;
}
/**
 * 
 * @export
 * @interface LetturaDatiClientiPFResponse
 */
export interface LetturaDatiClientiPFResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof LetturaDatiClientiPFResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {LetturaDatiClientePF}
     * @memberof LetturaDatiClientiPFResponse
     */
    'data'?: LetturaDatiClientePF;
}
/**
 * 
 * @export
 * @interface LetturaDatiClientiPGResponse
 */
export interface LetturaDatiClientiPGResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof LetturaDatiClientiPGResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {LetturaDatiClientePG}
     * @memberof LetturaDatiClientiPGResponse
     */
    'data'?: LetturaDatiClientePG;
}
/**
 * 
 * @export
 * @interface Linea
 */
export interface Linea {
    /**
     * 
     * @type {string}
     * @memberof Linea
     */
    'codTitolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Linea
     */
    'codMandato'?: string;
    /**
     * 
     * @type {string}
     * @memberof Linea
     */
    'dataRiferimento'?: string;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'valoreNominale'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'prezzoAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Linea
     */
    'dataUltimoPrezzo'?: string;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'rateoLordo'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'rateoNetto'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'cambioAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Linea
     */
    'dataUltimoCambio'?: string;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'controvaloreEuro'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'controvaloreValuta'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'componenteNonFin'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'prezzoMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'cambioMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'percPlusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'controvalorePlusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'premiVersati'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'controvalorePrenotatoDare'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'numQuotePrenotateDare'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'controvalorePrenotatoAvere'?: number;
    /**
     * 
     * @type {number}
     * @memberof Linea
     */
    'numQuotePrenotateAvere'?: number;
    /**
     * 
     * @type {Array<Sottostante>}
     * @memberof Linea
     */
    'sottostanti'?: Array<Sottostante>;
}
/**
 * 
 * @export
 * @interface LineaAllOf
 */
export interface LineaAllOf {
    /**
     * 
     * @type {Array<Sottostante>}
     * @memberof LineaAllOf
     */
    'sottostanti'?: Array<Sottostante>;
}
/**
 * 
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface MovimentoPIR
 */
export interface MovimentoPIR {
    /**
     * 
     * @type {number}
     * @memberof MovimentoPIR
     */
    'importoInvestito'?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoPIR
     */
    'importoDisinvestito'?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoPIR
     */
    'numQuote'?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoPIR
     */
    'codDivisa'?: string;
    /**
     * 
     * @type {string}
     * @memberof MovimentoPIR
     */
    'dataInizioHoldingPeriod'?: string;
    /**
     * 
     * @type {string}
     * @memberof MovimentoPIR
     */
    'dataFineHoldingPeriod'?: string;
    /**
     * 
     * @type {string}
     * @memberof MovimentoPIR
     */
    'dataRegolamento'?: string;
}
/**
 * 
 * @export
 * @interface OperazioneRicorrente
 */
export interface OperazioneRicorrente {
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'progressivoMovimento'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'codStrumento'?: string;
    /**
     * 
     * @type {number}
     * @memberof OperazioneRicorrente
     */
    'controvaloreRata'?: number;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'codiceCausale'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'codRapportoDestinazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'codPeriodicita'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'dataRichiesta'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'dataInizioValidita'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'dataFineValidita'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioneRicorrente
     */
    'codTitoloDestinazione'?: string;
    /**
     * 
     * @type {number}
     * @memberof OperazioneRicorrente
     */
    'durata'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperazioneRicorrente
     */
    'numRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperazioneRicorrente
     */
    'numRateResidue'?: number;
}
/**
 * 
 * @export
 * @interface OperazioniSimulate
 */
export interface OperazioniSimulate {
    /**
     * 
     * @type {string}
     * @memberof OperazioniSimulate
     */
    'codRapportoPir'?: string;
    /**
     * Campo valorizzato il campo con la tipologia di operazione simulata (21 sottoscrizione, 41 versamento aggiuntivo, 61 rimborso, 81 switch, al momento degli sviluppi non sono previsti switch per prodotti FIA)
     * @type {string}
     * @memberof OperazioniSimulate
     */
    'codTipoOperazione'?: string;
    /**
     * Campo valorizzato in base alla tipologia di movimento (01 versamento iniziale, 02 versamento successivo, 03 disinvestimento parziale, 04 disinvestimento totale)
     * @type {string}
     * @memberof OperazioniSimulate
     */
    'causaleMovimento'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioniSimulate
     */
    'codMandato'?: string;
    /**
     * 
     * @type {string}
     * @memberof OperazioniSimulate
     */
    'codTitolo'?: string;
    /**
     * 
     * @type {number}
     * @memberof OperazioniSimulate
     */
    'importoSimulato'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperazioniSimulate
     */
    'numQuoteSimulate'?: number;
    /**
     * Valorizzare in caso di operazione di switch con la concatenazione di codTitolo e codMandato oggetto dell\'investimento. Null negli altri casi
     * @type {string}
     * @memberof OperazioniSimulate
     */
    'codRapportoGambaIn'?: string;
    /**
     * Valorizzare in caso di operazione di switch con la concatenazione di codTitolo e codMandato oggetto del disinvestimento. Null negli altri casi
     * @type {string}
     * @memberof OperazioniSimulate
     */
    'codRapportoGambaOut'?: string;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'page'?: number;
}
/**
 * 
 * @export
 * @interface PortafoglioCliente
 */
export interface PortafoglioCliente {
    /**
     * 
     * @type {string}
     * @memberof PortafoglioCliente
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortafoglioCliente
     */
    'nomeCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortafoglioCliente
     */
    'cognomeCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortafoglioCliente
     */
    'codBanca'?: string;
    /**
     * 
     * @type {Array<RapportoPadre>}
     * @memberof PortafoglioCliente
     */
    'rapportiPadre'?: Array<RapportoPadre>;
}
/**
 * 
 * @export
 * @interface Posizione
 */
export interface Posizione {
    /**
     * 
     * @type {string}
     * @memberof Posizione
     */
    'codTitolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Posizione
     */
    'codMandato'?: string;
    /**
     * 
     * @type {string}
     * @memberof Posizione
     */
    'dataRiferimento'?: string;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'valoreNominale'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'prezzoAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Posizione
     */
    'dataUltimoPrezzo'?: string;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'rateoLordo'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'rateoNetto'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'cambioAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Posizione
     */
    'dataUltimoCambio'?: string;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'controvaloreEuro'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'controvaloreValuta'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'componenteNonFin'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'prezzoMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'cambioMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'percPlusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'controvalorePlusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'premiVersati'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'controvalorePrenotatoDare'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'numQuotePrenotateDare'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'controvalorePrenotatoAvere'?: number;
    /**
     * 
     * @type {number}
     * @memberof Posizione
     */
    'numQuotePrenotateAvere'?: number;
    /**
     * 
     * @type {Array<OperazioneRicorrente>}
     * @memberof Posizione
     */
    'infoOperazioniRicorrenti'?: Array<OperazioneRicorrente>;
    /**
     * 
     * @type {Array<Sottostante>}
     * @memberof Posizione
     */
    'sottostanti'?: Array<Sottostante>;
    /**
     * 
     * @type {Array<Linea>}
     * @memberof Posizione
     */
    'lineeWrapper'?: Array<Linea>;
}
/**
 * 
 * @export
 * @interface PosizioneAllOf
 */
export interface PosizioneAllOf {
    /**
     * 
     * @type {Array<OperazioneRicorrente>}
     * @memberof PosizioneAllOf
     */
    'infoOperazioniRicorrenti'?: Array<OperazioneRicorrente>;
    /**
     * 
     * @type {Array<Sottostante>}
     * @memberof PosizioneAllOf
     */
    'sottostanti'?: Array<Sottostante>;
    /**
     * 
     * @type {Array<Linea>}
     * @memberof PosizioneAllOf
     */
    'lineeWrapper'?: Array<Linea>;
}
/**
 * 
 * @export
 * @interface PosizionePIR
 */
export interface PosizionePIR {
    /**
     * 
     * @type {string}
     * @memberof PosizionePIR
     */
    'codMandatoPir'?: string;
    /**
     * 
     * @type {string}
     * @memberof PosizionePIR
     */
    'codPianoPir'?: string;
    /**
     * 
     * @type {string}
     * @memberof PosizionePIR
     */
    'codTitolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PosizionePIR
     */
    'desProdotto'?: string;
    /**
     * 
     * @type {string}
     * @memberof PosizionePIR
     */
    'codMandato'?: string;
    /**
     * 
     * @type {number}
     * @memberof PosizionePIR
     */
    'importoTotInvestito'?: number;
    /**
     * 
     * @type {number}
     * @memberof PosizionePIR
     */
    'importoTotDisinvestito'?: number;
    /**
     * 
     * @type {number}
     * @memberof PosizionePIR
     */
    'importoCommittment'?: number;
    /**
     * 
     * @type {number}
     * @memberof PosizionePIR
     */
    'CMPComplessivo'?: number;
    /**
     * 
     * @type {number}
     * @memberof PosizionePIR
     */
    'percentualeConcentrazione'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PosizionePIR
     */
    'flagLimiteConcentrazioneSuperato'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PosizionePIR
     */
    'flagCompliant'?: boolean;
    /**
     * 
     * @type {Array<MovimentoPIR>}
     * @memberof PosizionePIR
     */
    'movimenti'?: Array<MovimentoPIR>;
}
/**
 * 
 * @export
 * @interface Rapporto
 */
export interface Rapporto {
    /**
     * 
     * @type {string}
     * @memberof Rapporto
     */
    'codRapporto'?: string;
    /**
     * 
     * @type {Posizione}
     * @memberof Rapporto
     */
    'posizione'?: Posizione;
    /**
     * 
     * @type {Array<SoggettoCollegato>}
     * @memberof Rapporto
     */
    'soggettiCollegati'?: Array<SoggettoCollegato>;
}
/**
 * 
 * @export
 * @interface RapportoPadre
 */
export interface RapportoPadre {
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codFiliale'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codRapporto'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codSottoRapporto'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codClienteRubricato'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'numeroPolizza'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RapportoPadre
     */
    'flagScudato'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codTipoRapporto'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codSottoTipoRapporto'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codStato'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'desStato'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'dataApertura'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RapportoPadre
     */
    'flagVisibile'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codServizio'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'codRapportoPir'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportoPadre
     */
    'dataScadenzaPirBox'?: string;
    /**
     * 
     * @type {DossierRapporto}
     * @memberof RapportoPadre
     */
    'dossier'?: DossierRapporto;
    /**
     * 
     * @type {Array<Vincolo>}
     * @memberof RapportoPadre
     */
    'vincoli'?: Array<Vincolo>;
    /**
     * 
     * @type {Array<GestoreAssociato>}
     * @memberof RapportoPadre
     */
    'gestoriAssociati'?: Array<GestoreAssociato>;
    /**
     * 
     * @type {InfoPac}
     * @memberof RapportoPadre
     */
    'infoPac'?: InfoPac;
    /**
     * 
     * @type {Array<Rapporto>}
     * @memberof RapportoPadre
     */
    'rapporti'?: Array<Rapporto>;
}
/**
 * 
 * @export
 * @interface RecuperaDatiAgentiResponse
 */
export interface RecuperaDatiAgentiResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof RecuperaDatiAgentiResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {DatiAgente}
     * @memberof RecuperaDatiAgentiResponse
     */
    'data'?: DatiAgente;
}
/**
 * 
 * @export
 * @interface RecuperaPortafoglioClientiResponse
 */
export interface RecuperaPortafoglioClientiResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof RecuperaPortafoglioClientiResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {PortafoglioCliente}
     * @memberof RecuperaPortafoglioClientiResponse
     */
    'data'?: PortafoglioCliente;
}
/**
 * 
 * @export
 * @interface RicercaClientePFInner
 */
export interface RicercaClientePFInner {
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePFInner
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePFInner
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePFInner
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePFInner
     */
    'codFiscale'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePFInner
     */
    'dataNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePFInner
     */
    'cellulare'?: string;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof RicercaClientePFInner
     */
    'residenza'?: IndirizzoNFE;
}
/**
 * 
 * @export
 * @interface RicercaClientePGInner
 */
export interface RicercaClientePGInner {
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePGInner
     */
    'codCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePGInner
     */
    'denominazione'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePGInner
     */
    'pIva'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePGInner
     */
    'codFiscale'?: string;
    /**
     * 
     * @type {string}
     * @memberof RicercaClientePGInner
     */
    'cellulare'?: string;
    /**
     * 
     * @type {IndirizzoNFE}
     * @memberof RicercaClientePGInner
     */
    'residenza'?: IndirizzoNFE;
}
/**
 * 
 * @export
 * @interface RicercaClientiPFResponse
 */
export interface RicercaClientiPFResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof RicercaClientiPFResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {Array<RicercaClientePFInner>}
     * @memberof RicercaClientiPFResponse
     */
    'data'?: Array<RicercaClientePFInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof RicercaClientiPFResponse
     */
    'pagination'?: Pagination;
}
/**
 * 
 * @export
 * @interface RicercaClientiPGResponse
 */
export interface RicercaClientiPGResponse {
    /**
     * 
     * @type {Metadata}
     * @memberof RicercaClientiPGResponse
     */
    'metadata'?: Metadata;
    /**
     * 
     * @type {Array<RicercaClientePGInner>}
     * @memberof RicercaClientiPGResponse
     */
    'data'?: Array<RicercaClientePGInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof RicercaClientiPGResponse
     */
    'pagination'?: Pagination;
}
/**
 * 
 * @export
 * @interface Saldo
 */
export interface Saldo {
    /**
     * 
     * @type {string}
     * @memberof Saldo
     */
    'codTitolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Saldo
     */
    'codMandato'?: string;
    /**
     * 
     * @type {string}
     * @memberof Saldo
     */
    'dataRiferimento'?: string;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'valoreNominale'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'prezzoAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Saldo
     */
    'dataUltimoPrezzo'?: string;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'rateoLordo'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'rateoNetto'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'cambioAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Saldo
     */
    'dataUltimoCambio'?: string;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'controvaloreEuro'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'controvaloreValuta'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'componenteNonFin'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'prezzoMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'cambioMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'percPlusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'controvalorePlusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'premiVersati'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'controvalorePrenotatoDare'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'numQuotePrenotateDare'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'controvalorePrenotatoAvere'?: number;
    /**
     * 
     * @type {number}
     * @memberof Saldo
     */
    'numQuotePrenotateAvere'?: number;
}
/**
 * 
 * @export
 * @interface SoggettoCollegato
 */
export interface SoggettoCollegato {
    /**
     * 
     * @type {string}
     * @memberof SoggettoCollegato
     */
    'codTipologiaAnagrafica'?: string;
    /**
     * 
     * @type {string}
     * @memberof SoggettoCollegato
     */
    'codClente'?: string;
    /**
     * 
     * @type {string}
     * @memberof SoggettoCollegato
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof SoggettoCollegato
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof SoggettoCollegato
     */
    'dataNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof SoggettoCollegato
     */
    'descrizione'?: string;
}
/**
 * 
 * @export
 * @interface Sottostante
 */
export interface Sottostante {
    /**
     * 
     * @type {string}
     * @memberof Sottostante
     */
    'codTitolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Sottostante
     */
    'valoreNominale'?: string;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'prezzoAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Sottostante
     */
    'dataUltimoPrezzo'?: string;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'cambioAttuale'?: number;
    /**
     * 
     * @type {string}
     * @memberof Sottostante
     */
    'dataUltimoCambio'?: string;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'controvaloreEuro'?: number;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'controvaloreValuta'?: number;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'prezzoMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'cambioMedioCarico'?: number;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'percPlusMinus'?: number;
    /**
     * 
     * @type {number}
     * @memberof Sottostante
     */
    'controvalorePlusMinus'?: number;
}
/**
 * 
 * @export
 * @interface Vincolo
 */
export interface Vincolo {
    /**
     * 
     * @type {string}
     * @memberof Vincolo
     */
    'codVincolo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vincolo
     */
    'desVincolo'?: string;
}
/**
 * 
 * @export
 * @interface VisualizzaDettaglioProdottiResponse
 */
export interface VisualizzaDettaglioProdottiResponse {
    /**
     * 
     * @type {Array<PosizionePIR>}
     * @memberof VisualizzaDettaglioProdottiResponse
     */
    'posizioni'?: Array<PosizionePIR>;
}
/**
 * 
 * @export
 * @interface VisualizzaGraficoPIRResponse
 */
export interface VisualizzaGraficoPIRResponse {
    /**
     * 
     * @type {string}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'codMandatoPir'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'codPianoPir'?: string;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'importoTotInvestibile'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'importoTotNetto'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'residuoTotInvestibile'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'percentualeCompliant'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'percentualeNoCompliant'?: number;
    /**
     * 
     * @type {Array<Anno>}
     * @memberof VisualizzaGraficoPIRResponse
     */
    'anni'?: Array<Anno>;
}
/**
 * 
 * @export
 * @interface VisualizzaTabellaRiepilogoResponse
 */
export interface VisualizzaTabellaRiepilogoResponse {
    /**
     * 
     * @type {string}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'codMandatoPir'?: string;
    /**
     * 
     * @type {string}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'codPianoPir'?: string;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'importoTotInvestibile'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'importoTotNetto'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'residuoTotInvestibile'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'importoMaxInvestibileAnno'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'importoInvestitoAnno'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'residuoInvestibileAnno'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'importoDisinvestitoAnno'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'importoTotCommittment'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'percentualeCompliant'?: number;
    /**
     * 
     * @type {number}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'percentualeNoCompliant'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'flagLimiteComposizioneSuperato'?: boolean;
    /**
     * 
     * @type {Array<DettagliProdotti>}
     * @memberof VisualizzaTabellaRiepilogoResponse
     */
    'dettagliProdotti'?: Array<DettagliProdotti>;
}

/**
 * AnagraficaApi - axios parameter creator
 * @export
 */
export const AnagraficaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona fisica dato in input il corrispettivo codice cliente.
         * @summary Ricerca informazioni cliente per persona fisica
         * @param {string} codCliente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2LetturaDatiClientiPFGet: async (codCliente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('anagraficaV2LetturaDatiClientiPFGet', 'codCliente', codCliente)
            const localVarPath = `/anagrafica/v2/letturaDatiClientiPF`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input il corrispettivo codice cliente.
         * @summary Ricerca informazioni cliente per persona giuridica
         * @param {string} codCliente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2LetturaDatiClientiPGGet: async (codCliente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('anagraficaV2LetturaDatiClientiPGGet', 'codCliente', codCliente)
            const localVarPath = `/anagrafica/v2/letturaDatiClientiPG`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per recuperare la gerarchia commerciale di un consulente finanziario dato in input il suo codice agente.
         * @summary Ricerca le informazioni della gerarchia di un agente
         * @param {string} codAgente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2LetturaDatiGerarchieGet: async (codAgente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codAgente' is not null or undefined
            assertParamExists('anagraficaV2LetturaDatiGerarchieGet', 'codAgente', codAgente)
            const localVarPath = `/anagrafica/v2/letturaDatiGerarchie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per il recupero delle informazioni di dettaglio del consulente finanziario dato in input un codice utente. Il codice utente può essere alternativamente valorizzato o con il codice agente oppure con il suo codice cliente.
         * @summary Ricerca informazioni agente
         * @param {string} [codAgente] codice agente
         * @param {string} [codClienteAgente] codice cliente di un agente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RecuperaDatiAgentiGet: async (codAgente?: string, codClienteAgente?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/anagrafica/v2/recuperaDatiAgenti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }

            if (codClienteAgente !== undefined) {
                localVarQueryParameter['codClienteAgente'] = codClienteAgente;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per la ricerca del codice cliente di una persona fisica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
         * @summary Ricerca codice cliente per persona fisica
         * @param {string} codAgente codice agente
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {string} [cognome] cognome del cliente
         * @param {string} [nome] nome del cliente
         * @param {string} [codFiscale] codice fiscale del cliente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RicercaClientiPFGet: async (codAgente: string, perPage: number, page: number, cognome?: string, nome?: string, codFiscale?: string, codGerarchia?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codAgente' is not null or undefined
            assertParamExists('anagraficaV2RicercaClientiPFGet', 'codAgente', codAgente)
            // verify required parameter 'perPage' is not null or undefined
            assertParamExists('anagraficaV2RicercaClientiPFGet', 'perPage', perPage)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('anagraficaV2RicercaClientiPFGet', 'page', page)
            const localVarPath = `/anagrafica/v2/ricercaClientiPF`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cognome !== undefined) {
                localVarQueryParameter['cognome'] = cognome;
            }

            if (nome !== undefined) {
                localVarQueryParameter['nome'] = nome;
            }

            if (codFiscale !== undefined) {
                localVarQueryParameter['codFiscale'] = codFiscale;
            }

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }

            if (codGerarchia !== undefined) {
                localVarQueryParameter['codGerarchia'] = codGerarchia;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per la ricerca del codice cliente di una persona giuridica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
         * @summary Ricerca codice cliente per persona giuridica
         * @param {string} codAgente codice agente
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {string} [denominazione] ragione sociale o denominazione
         * @param {string} [pIva] partita iva
         * @param {string} [codFiscale] codice fiscale del cliente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RicercaClientiPGGet: async (codAgente: string, perPage: number, page: number, denominazione?: string, pIva?: string, codFiscale?: string, codGerarchia?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codAgente' is not null or undefined
            assertParamExists('anagraficaV2RicercaClientiPGGet', 'codAgente', codAgente)
            // verify required parameter 'perPage' is not null or undefined
            assertParamExists('anagraficaV2RicercaClientiPGGet', 'perPage', perPage)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('anagraficaV2RicercaClientiPGGet', 'page', page)
            const localVarPath = `/anagrafica/v2/ricercaClientiPG`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (denominazione !== undefined) {
                localVarQueryParameter['denominazione'] = denominazione;
            }

            if (pIva !== undefined) {
                localVarQueryParameter['pIva'] = pIva;
            }

            if (codFiscale !== undefined) {
                localVarQueryParameter['codFiscale'] = codFiscale;
            }

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }

            if (codGerarchia !== undefined) {
                localVarQueryParameter['codGerarchia'] = codGerarchia;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnagraficaApi - functional programming interface
 * @export
 */
export const AnagraficaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnagraficaApiAxiosParamCreator(configuration)
    return {
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona fisica dato in input il corrispettivo codice cliente.
         * @summary Ricerca informazioni cliente per persona fisica
         * @param {string} codCliente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2LetturaDatiClientiPFGet(codCliente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LetturaDatiClientiPFResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2LetturaDatiClientiPFGet(codCliente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input il corrispettivo codice cliente.
         * @summary Ricerca informazioni cliente per persona giuridica
         * @param {string} codCliente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2LetturaDatiClientiPGGet(codCliente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LetturaDatiClientiPGResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2LetturaDatiClientiPGGet(codCliente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per recuperare la gerarchia commerciale di un consulente finanziario dato in input il suo codice agente.
         * @summary Ricerca le informazioni della gerarchia di un agente
         * @param {string} codAgente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2LetturaDatiGerarchieGet(codAgente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatiGerarchieResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2LetturaDatiGerarchieGet(codAgente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per il recupero delle informazioni di dettaglio del consulente finanziario dato in input un codice utente. Il codice utente può essere alternativamente valorizzato o con il codice agente oppure con il suo codice cliente.
         * @summary Ricerca informazioni agente
         * @param {string} [codAgente] codice agente
         * @param {string} [codClienteAgente] codice cliente di un agente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2RecuperaDatiAgentiGet(codAgente?: string, codClienteAgente?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecuperaDatiAgentiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2RecuperaDatiAgentiGet(codAgente, codClienteAgente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per la ricerca del codice cliente di una persona fisica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
         * @summary Ricerca codice cliente per persona fisica
         * @param {string} codAgente codice agente
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {string} [cognome] cognome del cliente
         * @param {string} [nome] nome del cliente
         * @param {string} [codFiscale] codice fiscale del cliente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2RicercaClientiPFGet(codAgente: string, perPage: number, page: number, cognome?: string, nome?: string, codFiscale?: string, codGerarchia?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RicercaClientiPFResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2RicercaClientiPFGet(codAgente, perPage, page, cognome, nome, codFiscale, codGerarchia, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per la ricerca del codice cliente di una persona giuridica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
         * @summary Ricerca codice cliente per persona giuridica
         * @param {string} codAgente codice agente
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {string} [denominazione] ragione sociale o denominazione
         * @param {string} [pIva] partita iva
         * @param {string} [codFiscale] codice fiscale del cliente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2RicercaClientiPGGet(codAgente: string, perPage: number, page: number, denominazione?: string, pIva?: string, codFiscale?: string, codGerarchia?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RicercaClientiPGResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2RicercaClientiPGGet(codAgente, perPage, page, denominazione, pIva, codFiscale, codGerarchia, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnagraficaApi - factory interface
 * @export
 */
export const AnagraficaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnagraficaApiFp(configuration)
    return {
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona fisica dato in input il corrispettivo codice cliente.
         * @summary Ricerca informazioni cliente per persona fisica
         * @param {string} codCliente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2LetturaDatiClientiPFGet(codCliente: string, options?: any): AxiosPromise<LetturaDatiClientiPFResponse> {
            return localVarFp.anagraficaV2LetturaDatiClientiPFGet(codCliente, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input il corrispettivo codice cliente.
         * @summary Ricerca informazioni cliente per persona giuridica
         * @param {string} codCliente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2LetturaDatiClientiPGGet(codCliente: string, options?: any): AxiosPromise<LetturaDatiClientiPGResponse> {
            return localVarFp.anagraficaV2LetturaDatiClientiPGGet(codCliente, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per recuperare la gerarchia commerciale di un consulente finanziario dato in input il suo codice agente.
         * @summary Ricerca le informazioni della gerarchia di un agente
         * @param {string} codAgente codice cliente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2LetturaDatiGerarchieGet(codAgente: string, options?: any): AxiosPromise<DatiGerarchieResponse> {
            return localVarFp.anagraficaV2LetturaDatiGerarchieGet(codAgente, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per il recupero delle informazioni di dettaglio del consulente finanziario dato in input un codice utente. Il codice utente può essere alternativamente valorizzato o con il codice agente oppure con il suo codice cliente.
         * @summary Ricerca informazioni agente
         * @param {string} [codAgente] codice agente
         * @param {string} [codClienteAgente] codice cliente di un agente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RecuperaDatiAgentiGet(codAgente?: string, codClienteAgente?: string, options?: any): AxiosPromise<RecuperaDatiAgentiResponse> {
            return localVarFp.anagraficaV2RecuperaDatiAgentiGet(codAgente, codClienteAgente, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per la ricerca del codice cliente di una persona fisica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
         * @summary Ricerca codice cliente per persona fisica
         * @param {string} codAgente codice agente
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {string} [cognome] cognome del cliente
         * @param {string} [nome] nome del cliente
         * @param {string} [codFiscale] codice fiscale del cliente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RicercaClientiPFGet(codAgente: string, perPage: number, page: number, cognome?: string, nome?: string, codFiscale?: string, codGerarchia?: string, options?: any): AxiosPromise<RicercaClientiPFResponse> {
            return localVarFp.anagraficaV2RicercaClientiPFGet(codAgente, perPage, page, cognome, nome, codFiscale, codGerarchia, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per la ricerca del codice cliente di una persona giuridica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
         * @summary Ricerca codice cliente per persona giuridica
         * @param {string} codAgente codice agente
         * @param {number} perPage numero di oggetti per pagina
         * @param {number} page numero della pagina da mostrare
         * @param {string} [denominazione] ragione sociale o denominazione
         * @param {string} [pIva] partita iva
         * @param {string} [codFiscale] codice fiscale del cliente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2RicercaClientiPGGet(codAgente: string, perPage: number, page: number, denominazione?: string, pIva?: string, codFiscale?: string, codGerarchia?: string, options?: any): AxiosPromise<RicercaClientiPGResponse> {
            return localVarFp.anagraficaV2RicercaClientiPGGet(codAgente, perPage, page, denominazione, pIva, codFiscale, codGerarchia, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for anagraficaV2LetturaDatiClientiPFGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiAnagraficaV2LetturaDatiClientiPFGetRequest
 */
export interface AnagraficaApiAnagraficaV2LetturaDatiClientiPFGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2LetturaDatiClientiPFGet
     */
    readonly codCliente: string
}

/**
 * Request parameters for anagraficaV2LetturaDatiClientiPGGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiAnagraficaV2LetturaDatiClientiPGGetRequest
 */
export interface AnagraficaApiAnagraficaV2LetturaDatiClientiPGGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2LetturaDatiClientiPGGet
     */
    readonly codCliente: string
}

/**
 * Request parameters for anagraficaV2LetturaDatiGerarchieGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiAnagraficaV2LetturaDatiGerarchieGetRequest
 */
export interface AnagraficaApiAnagraficaV2LetturaDatiGerarchieGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2LetturaDatiGerarchieGet
     */
    readonly codAgente: string
}

/**
 * Request parameters for anagraficaV2RecuperaDatiAgentiGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiAnagraficaV2RecuperaDatiAgentiGetRequest
 */
export interface AnagraficaApiAnagraficaV2RecuperaDatiAgentiGetRequest {
    /**
     * codice agente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RecuperaDatiAgentiGet
     */
    readonly codAgente?: string

    /**
     * codice cliente di un agente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RecuperaDatiAgentiGet
     */
    readonly codClienteAgente?: string
}

/**
 * Request parameters for anagraficaV2RicercaClientiPFGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiAnagraficaV2RicercaClientiPFGetRequest
 */
export interface AnagraficaApiAnagraficaV2RicercaClientiPFGetRequest {
    /**
     * codice agente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPFGet
     */
    readonly codAgente: string

    /**
     * numero di oggetti per pagina
     * @type {number}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPFGet
     */
    readonly perPage: number

    /**
     * numero della pagina da mostrare
     * @type {number}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPFGet
     */
    readonly page: number

    /**
     * cognome del cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPFGet
     */
    readonly cognome?: string

    /**
     * nome del cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPFGet
     */
    readonly nome?: string

    /**
     * codice fiscale del cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPFGet
     */
    readonly codFiscale?: string

    /**
     * codice gerarchia
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPFGet
     */
    readonly codGerarchia?: string
}

/**
 * Request parameters for anagraficaV2RicercaClientiPGGet operation in AnagraficaApi.
 * @export
 * @interface AnagraficaApiAnagraficaV2RicercaClientiPGGetRequest
 */
export interface AnagraficaApiAnagraficaV2RicercaClientiPGGetRequest {
    /**
     * codice agente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPGGet
     */
    readonly codAgente: string

    /**
     * numero di oggetti per pagina
     * @type {number}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPGGet
     */
    readonly perPage: number

    /**
     * numero della pagina da mostrare
     * @type {number}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPGGet
     */
    readonly page: number

    /**
     * ragione sociale o denominazione
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPGGet
     */
    readonly denominazione?: string

    /**
     * partita iva
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPGGet
     */
    readonly pIva?: string

    /**
     * codice fiscale del cliente
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPGGet
     */
    readonly codFiscale?: string

    /**
     * codice gerarchia
     * @type {string}
     * @memberof AnagraficaApiAnagraficaV2RicercaClientiPGGet
     */
    readonly codGerarchia?: string
}

/**
 * AnagraficaApi - object-oriented interface
 * @export
 * @class AnagraficaApi
 * @extends {BaseAPI}
 */
export class AnagraficaApi extends BaseAPI {
    /**
     * Api per la lettura delle informazioni anagrafiche di una persona fisica dato in input il corrispettivo codice cliente.
     * @summary Ricerca informazioni cliente per persona fisica
     * @param {AnagraficaApiAnagraficaV2LetturaDatiClientiPFGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public anagraficaV2LetturaDatiClientiPFGet(requestParameters: AnagraficaApiAnagraficaV2LetturaDatiClientiPFGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).anagraficaV2LetturaDatiClientiPFGet(requestParameters.codCliente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per la lettura delle informazioni anagrafiche di una persona giuridica dato in input il corrispettivo codice cliente.
     * @summary Ricerca informazioni cliente per persona giuridica
     * @param {AnagraficaApiAnagraficaV2LetturaDatiClientiPGGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public anagraficaV2LetturaDatiClientiPGGet(requestParameters: AnagraficaApiAnagraficaV2LetturaDatiClientiPGGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).anagraficaV2LetturaDatiClientiPGGet(requestParameters.codCliente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per recuperare la gerarchia commerciale di un consulente finanziario dato in input il suo codice agente.
     * @summary Ricerca le informazioni della gerarchia di un agente
     * @param {AnagraficaApiAnagraficaV2LetturaDatiGerarchieGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public anagraficaV2LetturaDatiGerarchieGet(requestParameters: AnagraficaApiAnagraficaV2LetturaDatiGerarchieGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).anagraficaV2LetturaDatiGerarchieGet(requestParameters.codAgente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per il recupero delle informazioni di dettaglio del consulente finanziario dato in input un codice utente. Il codice utente può essere alternativamente valorizzato o con il codice agente oppure con il suo codice cliente.
     * @summary Ricerca informazioni agente
     * @param {AnagraficaApiAnagraficaV2RecuperaDatiAgentiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public anagraficaV2RecuperaDatiAgentiGet(requestParameters: AnagraficaApiAnagraficaV2RecuperaDatiAgentiGetRequest = {}, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).anagraficaV2RecuperaDatiAgentiGet(requestParameters.codAgente, requestParameters.codClienteAgente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per la ricerca del codice cliente di una persona fisica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
     * @summary Ricerca codice cliente per persona fisica
     * @param {AnagraficaApiAnagraficaV2RicercaClientiPFGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public anagraficaV2RicercaClientiPFGet(requestParameters: AnagraficaApiAnagraficaV2RicercaClientiPFGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).anagraficaV2RicercaClientiPFGet(requestParameters.codAgente, requestParameters.perPage, requestParameters.page, requestParameters.cognome, requestParameters.nome, requestParameters.codFiscale, requestParameters.codGerarchia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per la ricerca del codice cliente di una persona giuridica dati alcuni parametri di ricerca. In base ai dati passati in input verrà restituito un codice o una lista di codici cliente.
     * @summary Ricerca codice cliente per persona giuridica
     * @param {AnagraficaApiAnagraficaV2RicercaClientiPGGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaApi
     */
    public anagraficaV2RicercaClientiPGGet(requestParameters: AnagraficaApiAnagraficaV2RicercaClientiPGGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaApiFp(this.configuration).anagraficaV2RicercaClientiPGGet(requestParameters.codAgente, requestParameters.perPage, requestParameters.page, requestParameters.denominazione, requestParameters.pIva, requestParameters.codFiscale, requestParameters.codGerarchia, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AnagraficaControlliApi - axios parameter creator
 * @export
 */
export const AnagraficaControlliApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Api per verificare l\'associazione tra una figura accessoria e una persona giuridica, dati in input rispettivamente il codice fiscale di una persona fisica e il codice cliente di una persona giuridica. In particolare, l\'Api verifica che il codice fiscale della persona fisica è relativo a una figura accessoria avente ruolo con potere di firma in uno dei dossier associati alla persona giuridica.
         * @summary Verifica associazione di una persona fisica ad una persona giuridica
         * @param {string} codClientePG codice cliente persona giuridica
         * @param {string} codFiscalePF codcie fiscale persona fisica
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaAssociazioniPFPGGet: async (codClientePG: string, codFiscalePF: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codClientePG' is not null or undefined
            assertParamExists('anagraficaV2VerificaAssociazioniPFPGGet', 'codClientePG', codClientePG)
            // verify required parameter 'codFiscalePF' is not null or undefined
            assertParamExists('anagraficaV2VerificaAssociazioniPFPGGet', 'codFiscalePF', codFiscalePF)
            const localVarPath = `/anagrafica/v2/verificaAssociazioniPFPG`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codClientePG !== undefined) {
                localVarQueryParameter['codClientePG'] = codClientePG;
            }

            if (codFiscalePF !== undefined) {
                localVarQueryParameter['codFiscalePF'] = codFiscalePF;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per verificare la presenza di alcuni vincoli anagrafici che non consentirebbero la registrazione in self al portale clienti di una persona fisica, dati come parametri in input codice cliente e codice fiscale. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
         * @summary Verifica possibilità di registrazione in self per persona fisica
         * @param {string} codCliente codice cliente
         * @param {string} codFiscale codice fiscale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaRegistrazioniInSelfPFGet: async (codCliente: string, codFiscale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('anagraficaV2VerificaRegistrazioniInSelfPFGet', 'codCliente', codCliente)
            // verify required parameter 'codFiscale' is not null or undefined
            assertParamExists('anagraficaV2VerificaRegistrazioniInSelfPFGet', 'codFiscale', codFiscale)
            const localVarPath = `/anagrafica/v2/verificaRegistrazioniInSelfPF`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (codFiscale !== undefined) {
                localVarQueryParameter['codFiscale'] = codFiscale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per verificare la possibilità di registrazione in self al portale clienti di una persona giuridica, dati come parametri in input codice cliente e partita iva. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
         * @summary Verifica possibilità di registrazione in self per persona giuridica
         * @param {string} codCliente codice cliente
         * @param {string} pIva partita iva
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaRegistrazioniInSelfPGGet: async (codCliente: string, pIva: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('anagraficaV2VerificaRegistrazioniInSelfPGGet', 'codCliente', codCliente)
            // verify required parameter 'pIva' is not null or undefined
            assertParamExists('anagraficaV2VerificaRegistrazioniInSelfPGGet', 'pIva', pIva)
            const localVarPath = `/anagrafica/v2/verificaRegistrazioniInSelfPG`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (pIva !== undefined) {
                localVarQueryParameter['pIva'] = pIva;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Api per verificare l\'univocità e l\'associazione tra un codice cliente e un numero di telefono, entrambi passati in input. Solo nel caso di persona giuridica, se il numero di telefono risulta associato ad un altro cliente, tale cliente deve essere necessariamente una figura accessoria associata alla PG data in input.
         * @summary Verifica associazione univoca del telefono rispetto ad un solo cliente
         * @param {string} codCliente codice cliente
         * @param {string} telefono numero di telefono
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaUnivocitaTelefonoGet: async (codCliente: string, telefono: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('anagraficaV2VerificaUnivocitaTelefonoGet', 'codCliente', codCliente)
            // verify required parameter 'telefono' is not null or undefined
            assertParamExists('anagraficaV2VerificaUnivocitaTelefonoGet', 'telefono', telefono)
            const localVarPath = `/anagrafica/v2/verificaUnivocitaTelefono`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (telefono !== undefined) {
                localVarQueryParameter['telefono'] = telefono;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnagraficaControlliApi - functional programming interface
 * @export
 */
export const AnagraficaControlliApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnagraficaControlliApiAxiosParamCreator(configuration)
    return {
        /**
         * Api per verificare l\'associazione tra una figura accessoria e una persona giuridica, dati in input rispettivamente il codice fiscale di una persona fisica e il codice cliente di una persona giuridica. In particolare, l\'Api verifica che il codice fiscale della persona fisica è relativo a una figura accessoria avente ruolo con potere di firma in uno dei dossier associati alla persona giuridica.
         * @summary Verifica associazione di una persona fisica ad una persona giuridica
         * @param {string} codClientePG codice cliente persona giuridica
         * @param {string} codFiscalePF codcie fiscale persona fisica
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2VerificaAssociazioniPFPGGet(codClientePG: string, codFiscalePF: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlliInSelfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2VerificaAssociazioniPFPGGet(codClientePG, codFiscalePF, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per verificare la presenza di alcuni vincoli anagrafici che non consentirebbero la registrazione in self al portale clienti di una persona fisica, dati come parametri in input codice cliente e codice fiscale. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
         * @summary Verifica possibilità di registrazione in self per persona fisica
         * @param {string} codCliente codice cliente
         * @param {string} codFiscale codice fiscale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2VerificaRegistrazioniInSelfPFGet(codCliente: string, codFiscale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlliInSelfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2VerificaRegistrazioniInSelfPFGet(codCliente, codFiscale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per verificare la possibilità di registrazione in self al portale clienti di una persona giuridica, dati come parametri in input codice cliente e partita iva. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
         * @summary Verifica possibilità di registrazione in self per persona giuridica
         * @param {string} codCliente codice cliente
         * @param {string} pIva partita iva
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2VerificaRegistrazioniInSelfPGGet(codCliente: string, pIva: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlliInSelfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2VerificaRegistrazioniInSelfPGGet(codCliente, pIva, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Api per verificare l\'univocità e l\'associazione tra un codice cliente e un numero di telefono, entrambi passati in input. Solo nel caso di persona giuridica, se il numero di telefono risulta associato ad un altro cliente, tale cliente deve essere necessariamente una figura accessoria associata alla PG data in input.
         * @summary Verifica associazione univoca del telefono rispetto ad un solo cliente
         * @param {string} codCliente codice cliente
         * @param {string} telefono numero di telefono
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anagraficaV2VerificaUnivocitaTelefonoGet(codCliente: string, telefono: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlliInSelfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anagraficaV2VerificaUnivocitaTelefonoGet(codCliente, telefono, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnagraficaControlliApi - factory interface
 * @export
 */
export const AnagraficaControlliApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnagraficaControlliApiFp(configuration)
    return {
        /**
         * Api per verificare l\'associazione tra una figura accessoria e una persona giuridica, dati in input rispettivamente il codice fiscale di una persona fisica e il codice cliente di una persona giuridica. In particolare, l\'Api verifica che il codice fiscale della persona fisica è relativo a una figura accessoria avente ruolo con potere di firma in uno dei dossier associati alla persona giuridica.
         * @summary Verifica associazione di una persona fisica ad una persona giuridica
         * @param {string} codClientePG codice cliente persona giuridica
         * @param {string} codFiscalePF codcie fiscale persona fisica
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaAssociazioniPFPGGet(codClientePG: string, codFiscalePF: string, options?: any): AxiosPromise<ControlliInSelfResponse> {
            return localVarFp.anagraficaV2VerificaAssociazioniPFPGGet(codClientePG, codFiscalePF, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per verificare la presenza di alcuni vincoli anagrafici che non consentirebbero la registrazione in self al portale clienti di una persona fisica, dati come parametri in input codice cliente e codice fiscale. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
         * @summary Verifica possibilità di registrazione in self per persona fisica
         * @param {string} codCliente codice cliente
         * @param {string} codFiscale codice fiscale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaRegistrazioniInSelfPFGet(codCliente: string, codFiscale: string, options?: any): AxiosPromise<ControlliInSelfResponse> {
            return localVarFp.anagraficaV2VerificaRegistrazioniInSelfPFGet(codCliente, codFiscale, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per verificare la possibilità di registrazione in self al portale clienti di una persona giuridica, dati come parametri in input codice cliente e partita iva. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
         * @summary Verifica possibilità di registrazione in self per persona giuridica
         * @param {string} codCliente codice cliente
         * @param {string} pIva partita iva
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaRegistrazioniInSelfPGGet(codCliente: string, pIva: string, options?: any): AxiosPromise<ControlliInSelfResponse> {
            return localVarFp.anagraficaV2VerificaRegistrazioniInSelfPGGet(codCliente, pIva, options).then((request) => request(axios, basePath));
        },
        /**
         * Api per verificare l\'univocità e l\'associazione tra un codice cliente e un numero di telefono, entrambi passati in input. Solo nel caso di persona giuridica, se il numero di telefono risulta associato ad un altro cliente, tale cliente deve essere necessariamente una figura accessoria associata alla PG data in input.
         * @summary Verifica associazione univoca del telefono rispetto ad un solo cliente
         * @param {string} codCliente codice cliente
         * @param {string} telefono numero di telefono
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anagraficaV2VerificaUnivocitaTelefonoGet(codCliente: string, telefono: string, options?: any): AxiosPromise<ControlliInSelfResponse> {
            return localVarFp.anagraficaV2VerificaUnivocitaTelefonoGet(codCliente, telefono, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for anagraficaV2VerificaAssociazioniPFPGGet operation in AnagraficaControlliApi.
 * @export
 * @interface AnagraficaControlliApiAnagraficaV2VerificaAssociazioniPFPGGetRequest
 */
export interface AnagraficaControlliApiAnagraficaV2VerificaAssociazioniPFPGGetRequest {
    /**
     * codice cliente persona giuridica
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaAssociazioniPFPGGet
     */
    readonly codClientePG: string

    /**
     * codcie fiscale persona fisica
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaAssociazioniPFPGGet
     */
    readonly codFiscalePF: string
}

/**
 * Request parameters for anagraficaV2VerificaRegistrazioniInSelfPFGet operation in AnagraficaControlliApi.
 * @export
 * @interface AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPFGetRequest
 */
export interface AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPFGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPFGet
     */
    readonly codCliente: string

    /**
     * codice fiscale
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPFGet
     */
    readonly codFiscale: string
}

/**
 * Request parameters for anagraficaV2VerificaRegistrazioniInSelfPGGet operation in AnagraficaControlliApi.
 * @export
 * @interface AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPGGetRequest
 */
export interface AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPGGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPGGet
     */
    readonly codCliente: string

    /**
     * partita iva
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPGGet
     */
    readonly pIva: string
}

/**
 * Request parameters for anagraficaV2VerificaUnivocitaTelefonoGet operation in AnagraficaControlliApi.
 * @export
 * @interface AnagraficaControlliApiAnagraficaV2VerificaUnivocitaTelefonoGetRequest
 */
export interface AnagraficaControlliApiAnagraficaV2VerificaUnivocitaTelefonoGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaUnivocitaTelefonoGet
     */
    readonly codCliente: string

    /**
     * numero di telefono
     * @type {string}
     * @memberof AnagraficaControlliApiAnagraficaV2VerificaUnivocitaTelefonoGet
     */
    readonly telefono: string
}

/**
 * AnagraficaControlliApi - object-oriented interface
 * @export
 * @class AnagraficaControlliApi
 * @extends {BaseAPI}
 */
export class AnagraficaControlliApi extends BaseAPI {
    /**
     * Api per verificare l\'associazione tra una figura accessoria e una persona giuridica, dati in input rispettivamente il codice fiscale di una persona fisica e il codice cliente di una persona giuridica. In particolare, l\'Api verifica che il codice fiscale della persona fisica è relativo a una figura accessoria avente ruolo con potere di firma in uno dei dossier associati alla persona giuridica.
     * @summary Verifica associazione di una persona fisica ad una persona giuridica
     * @param {AnagraficaControlliApiAnagraficaV2VerificaAssociazioniPFPGGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaControlliApi
     */
    public anagraficaV2VerificaAssociazioniPFPGGet(requestParameters: AnagraficaControlliApiAnagraficaV2VerificaAssociazioniPFPGGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaControlliApiFp(this.configuration).anagraficaV2VerificaAssociazioniPFPGGet(requestParameters.codClientePG, requestParameters.codFiscalePF, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per verificare la presenza di alcuni vincoli anagrafici che non consentirebbero la registrazione in self al portale clienti di una persona fisica, dati come parametri in input codice cliente e codice fiscale. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
     * @summary Verifica possibilità di registrazione in self per persona fisica
     * @param {AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPFGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaControlliApi
     */
    public anagraficaV2VerificaRegistrazioniInSelfPFGet(requestParameters: AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPFGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaControlliApiFp(this.configuration).anagraficaV2VerificaRegistrazioniInSelfPFGet(requestParameters.codCliente, requestParameters.codFiscale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per verificare la possibilità di registrazione in self al portale clienti di una persona giuridica, dati come parametri in input codice cliente e partita iva. L\'Api restituisce in output il numero e l\'elenco di controlli non superati con annesse descrizioni e motivazioni.
     * @summary Verifica possibilità di registrazione in self per persona giuridica
     * @param {AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPGGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaControlliApi
     */
    public anagraficaV2VerificaRegistrazioniInSelfPGGet(requestParameters: AnagraficaControlliApiAnagraficaV2VerificaRegistrazioniInSelfPGGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaControlliApiFp(this.configuration).anagraficaV2VerificaRegistrazioniInSelfPGGet(requestParameters.codCliente, requestParameters.pIva, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Api per verificare l\'univocità e l\'associazione tra un codice cliente e un numero di telefono, entrambi passati in input. Solo nel caso di persona giuridica, se il numero di telefono risulta associato ad un altro cliente, tale cliente deve essere necessariamente una figura accessoria associata alla PG data in input.
     * @summary Verifica associazione univoca del telefono rispetto ad un solo cliente
     * @param {AnagraficaControlliApiAnagraficaV2VerificaUnivocitaTelefonoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnagraficaControlliApi
     */
    public anagraficaV2VerificaUnivocitaTelefonoGet(requestParameters: AnagraficaControlliApiAnagraficaV2VerificaUnivocitaTelefonoGetRequest, options?: AxiosRequestConfig) {
        return AnagraficaControlliApiFp(this.configuration).anagraficaV2VerificaUnivocitaTelefonoGet(requestParameters.codCliente, requestParameters.telefono, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EnginePIRApi - axios parameter creator
 * @export
 */
export const EnginePIRApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Recupera dettaglio dei prodotti inclusi nel deposito PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePIRV1VisualizzaDettaglioProdottiGet: async (codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codAgente' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaDettaglioProdottiGet', 'codAgente', codAgente)
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaDettaglioProdottiGet', 'codCliente', codCliente)
            // verify required parameter 'codMandatoPir' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaDettaglioProdottiGet', 'codMandatoPir', codMandatoPir)
            const localVarPath = `/enginePIR/v1/visualizzaDettaglioProdotti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (codMandatoPir !== undefined) {
                localVarQueryParameter['codMandatoPir'] = codMandatoPir;
            }

            if (codPianoPir !== undefined) {
                localVarQueryParameter['codPianoPir'] = codPianoPir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recupera informazioni utili alla creazione dei grafici per il piano PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePIRV1VisualizzaGraficoPIRGet: async (codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codAgente' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaGraficoPIRGet', 'codAgente', codAgente)
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaGraficoPIRGet', 'codCliente', codCliente)
            // verify required parameter 'codMandatoPir' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaGraficoPIRGet', 'codMandatoPir', codMandatoPir)
            const localVarPath = `/enginePIR/v1/visualizzaGraficoPIR`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (codMandatoPir !== undefined) {
                localVarQueryParameter['codMandatoPir'] = codMandatoPir;
            }

            if (codPianoPir !== undefined) {
                localVarQueryParameter['codPianoPir'] = codPianoPir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recupera strumenti finanziari inclusi nel deposito PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePIRV1VisualizzaTabellaRiepilogoGet: async (codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codAgente' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaTabellaRiepilogoGet', 'codAgente', codAgente)
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaTabellaRiepilogoGet', 'codCliente', codCliente)
            // verify required parameter 'codMandatoPir' is not null or undefined
            assertParamExists('enginePIRV1VisualizzaTabellaRiepilogoGet', 'codMandatoPir', codMandatoPir)
            const localVarPath = `/enginePIR/v1/visualizzaTabellaRiepilogo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (codMandatoPir !== undefined) {
                localVarQueryParameter['codMandatoPir'] = codMandatoPir;
            }

            if (codPianoPir !== undefined) {
                localVarQueryParameter['codPianoPir'] = codPianoPir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnginePIRApi - functional programming interface
 * @export
 */
export const EnginePIRApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnginePIRApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Recupera dettaglio dei prodotti inclusi nel deposito PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enginePIRV1VisualizzaDettaglioProdottiGet(codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualizzaDettaglioProdottiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enginePIRV1VisualizzaDettaglioProdottiGet(codAgente, codCliente, codMandatoPir, codPianoPir, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Recupera informazioni utili alla creazione dei grafici per il piano PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enginePIRV1VisualizzaGraficoPIRGet(codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualizzaGraficoPIRResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enginePIRV1VisualizzaGraficoPIRGet(codAgente, codCliente, codMandatoPir, codPianoPir, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Recupera strumenti finanziari inclusi nel deposito PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enginePIRV1VisualizzaTabellaRiepilogoGet(codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisualizzaTabellaRiepilogoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enginePIRV1VisualizzaTabellaRiepilogoGet(codAgente, codCliente, codMandatoPir, codPianoPir, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnginePIRApi - factory interface
 * @export
 */
export const EnginePIRApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnginePIRApiFp(configuration)
    return {
        /**
         * 
         * @summary Recupera dettaglio dei prodotti inclusi nel deposito PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePIRV1VisualizzaDettaglioProdottiGet(codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options?: any): AxiosPromise<VisualizzaDettaglioProdottiResponse> {
            return localVarFp.enginePIRV1VisualizzaDettaglioProdottiGet(codAgente, codCliente, codMandatoPir, codPianoPir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recupera informazioni utili alla creazione dei grafici per il piano PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePIRV1VisualizzaGraficoPIRGet(codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options?: any): AxiosPromise<VisualizzaGraficoPIRResponse> {
            return localVarFp.enginePIRV1VisualizzaGraficoPIRGet(codAgente, codCliente, codMandatoPir, codPianoPir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recupera strumenti finanziari inclusi nel deposito PIR
         * @param {string} codAgente codice agente
         * @param {string} codCliente codice cliente
         * @param {string} codMandatoPir codice mandato PIR
         * @param {string} [codPianoPir] codice piano PIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePIRV1VisualizzaTabellaRiepilogoGet(codAgente: string, codCliente: string, codMandatoPir: string, codPianoPir?: string, options?: any): AxiosPromise<VisualizzaTabellaRiepilogoResponse> {
            return localVarFp.enginePIRV1VisualizzaTabellaRiepilogoGet(codAgente, codCliente, codMandatoPir, codPianoPir, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for enginePIRV1VisualizzaDettaglioProdottiGet operation in EnginePIRApi.
 * @export
 * @interface EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGetRequest
 */
export interface EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGetRequest {
    /**
     * codice agente
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGet
     */
    readonly codAgente: string

    /**
     * codice cliente
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGet
     */
    readonly codCliente: string

    /**
     * codice mandato PIR
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGet
     */
    readonly codMandatoPir: string

    /**
     * codice piano PIR
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGet
     */
    readonly codPianoPir?: string
}

/**
 * Request parameters for enginePIRV1VisualizzaGraficoPIRGet operation in EnginePIRApi.
 * @export
 * @interface EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGetRequest
 */
export interface EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGetRequest {
    /**
     * codice agente
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGet
     */
    readonly codAgente: string

    /**
     * codice cliente
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGet
     */
    readonly codCliente: string

    /**
     * codice mandato PIR
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGet
     */
    readonly codMandatoPir: string

    /**
     * codice piano PIR
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGet
     */
    readonly codPianoPir?: string
}

/**
 * Request parameters for enginePIRV1VisualizzaTabellaRiepilogoGet operation in EnginePIRApi.
 * @export
 * @interface EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGetRequest
 */
export interface EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGetRequest {
    /**
     * codice agente
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGet
     */
    readonly codAgente: string

    /**
     * codice cliente
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGet
     */
    readonly codCliente: string

    /**
     * codice mandato PIR
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGet
     */
    readonly codMandatoPir: string

    /**
     * codice piano PIR
     * @type {string}
     * @memberof EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGet
     */
    readonly codPianoPir?: string
}

/**
 * EnginePIRApi - object-oriented interface
 * @export
 * @class EnginePIRApi
 * @extends {BaseAPI}
 */
export class EnginePIRApi extends BaseAPI {
    /**
     * 
     * @summary Recupera dettaglio dei prodotti inclusi nel deposito PIR
     * @param {EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnginePIRApi
     */
    public enginePIRV1VisualizzaDettaglioProdottiGet(requestParameters: EnginePIRApiEnginePIRV1VisualizzaDettaglioProdottiGetRequest, options?: AxiosRequestConfig) {
        return EnginePIRApiFp(this.configuration).enginePIRV1VisualizzaDettaglioProdottiGet(requestParameters.codAgente, requestParameters.codCliente, requestParameters.codMandatoPir, requestParameters.codPianoPir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recupera informazioni utili alla creazione dei grafici per il piano PIR
     * @param {EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnginePIRApi
     */
    public enginePIRV1VisualizzaGraficoPIRGet(requestParameters: EnginePIRApiEnginePIRV1VisualizzaGraficoPIRGetRequest, options?: AxiosRequestConfig) {
        return EnginePIRApiFp(this.configuration).enginePIRV1VisualizzaGraficoPIRGet(requestParameters.codAgente, requestParameters.codCliente, requestParameters.codMandatoPir, requestParameters.codPianoPir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recupera strumenti finanziari inclusi nel deposito PIR
     * @param {EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnginePIRApi
     */
    public enginePIRV1VisualizzaTabellaRiepilogoGet(requestParameters: EnginePIRApiEnginePIRV1VisualizzaTabellaRiepilogoGetRequest, options?: AxiosRequestConfig) {
        return EnginePIRApiFp(this.configuration).enginePIRV1VisualizzaTabellaRiepilogoGet(requestParameters.codAgente, requestParameters.codCliente, requestParameters.codMandatoPir, requestParameters.codPianoPir, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EnginePortafoglioApi - axios parameter creator
 * @export
 */
export const EnginePortafoglioApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Recupera le informazioni di un portafoglio di un cliente
         * @param {string} codCliente codice cliente
         * @param {string} codAgente codice agente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePortafoglioV2RecuperaPortafoglioClientiGet: async (codCliente: string, codAgente: string, codGerarchia?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codCliente' is not null or undefined
            assertParamExists('enginePortafoglioV2RecuperaPortafoglioClientiGet', 'codCliente', codCliente)
            // verify required parameter 'codAgente' is not null or undefined
            assertParamExists('enginePortafoglioV2RecuperaPortafoglioClientiGet', 'codAgente', codAgente)
            const localVarPath = `/enginePortafoglio/v2/recuperaPortafoglioClienti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codCliente !== undefined) {
                localVarQueryParameter['codCliente'] = codCliente;
            }

            if (codAgente !== undefined) {
                localVarQueryParameter['codAgente'] = codAgente;
            }

            if (codGerarchia !== undefined) {
                localVarQueryParameter['codGerarchia'] = codGerarchia;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnginePortafoglioApi - functional programming interface
 * @export
 */
export const EnginePortafoglioApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnginePortafoglioApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Recupera le informazioni di un portafoglio di un cliente
         * @param {string} codCliente codice cliente
         * @param {string} codAgente codice agente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enginePortafoglioV2RecuperaPortafoglioClientiGet(codCliente: string, codAgente: string, codGerarchia?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecuperaPortafoglioClientiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enginePortafoglioV2RecuperaPortafoglioClientiGet(codCliente, codAgente, codGerarchia, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnginePortafoglioApi - factory interface
 * @export
 */
export const EnginePortafoglioApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnginePortafoglioApiFp(configuration)
    return {
        /**
         * 
         * @summary Recupera le informazioni di un portafoglio di un cliente
         * @param {string} codCliente codice cliente
         * @param {string} codAgente codice agente
         * @param {string} [codGerarchia] codice gerarchia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enginePortafoglioV2RecuperaPortafoglioClientiGet(codCliente: string, codAgente: string, codGerarchia?: string, options?: any): AxiosPromise<RecuperaPortafoglioClientiResponse> {
            return localVarFp.enginePortafoglioV2RecuperaPortafoglioClientiGet(codCliente, codAgente, codGerarchia, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for enginePortafoglioV2RecuperaPortafoglioClientiGet operation in EnginePortafoglioApi.
 * @export
 * @interface EnginePortafoglioApiEnginePortafoglioV2RecuperaPortafoglioClientiGetRequest
 */
export interface EnginePortafoglioApiEnginePortafoglioV2RecuperaPortafoglioClientiGetRequest {
    /**
     * codice cliente
     * @type {string}
     * @memberof EnginePortafoglioApiEnginePortafoglioV2RecuperaPortafoglioClientiGet
     */
    readonly codCliente: string

    /**
     * codice agente
     * @type {string}
     * @memberof EnginePortafoglioApiEnginePortafoglioV2RecuperaPortafoglioClientiGet
     */
    readonly codAgente: string

    /**
     * codice gerarchia
     * @type {string}
     * @memberof EnginePortafoglioApiEnginePortafoglioV2RecuperaPortafoglioClientiGet
     */
    readonly codGerarchia?: string
}

/**
 * EnginePortafoglioApi - object-oriented interface
 * @export
 * @class EnginePortafoglioApi
 * @extends {BaseAPI}
 */
export class EnginePortafoglioApi extends BaseAPI {
    /**
     * 
     * @summary Recupera le informazioni di un portafoglio di un cliente
     * @param {EnginePortafoglioApiEnginePortafoglioV2RecuperaPortafoglioClientiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnginePortafoglioApi
     */
    public enginePortafoglioV2RecuperaPortafoglioClientiGet(requestParameters: EnginePortafoglioApiEnginePortafoglioV2RecuperaPortafoglioClientiGetRequest, options?: AxiosRequestConfig) {
        return EnginePortafoglioApiFp(this.configuration).enginePortafoglioV2RecuperaPortafoglioClientiGet(requestParameters.codCliente, requestParameters.codAgente, requestParameters.codGerarchia, options).then((request) => request(this.axios, this.basePath));
    }
}


